export default {
  list: [],
  listMeta: {},
  listLoading: false,

  buyZupuLoading: false,
};
